import { IDeleteMultipleBaseRequest } from "../../../models/request/base/deleteRequest"
import { IPLTuanSelectRequest } from "../../../models/request/danh-muc/IPLTuanSelectRequest"
import { app_yeu_cau_ho_tro_group } from "../../../models/response/app-phuhuynh/app_yeu_cau_ho_tro_group"

export enum eYCHTGroupActionTypeIds {
    LOAD_START = "YCHT_GROUP_LOAD_START",
    LOAD_SUCCESS = "YCHT_GROUP_LOAD_SUCCESS",
    LOAD_ERROR = "YCHT_GROUP_LOAD_ERROR",

    SELECT_START = "YCHT_GROUP_SELECT_START",
    SELECT_SUCCESS = "YCHT_GROUP_SELECT_SUCCESS",
    SELECT_ERROR = "YCHT_GROUP_SELECT_ERROR",

    SHOW_DETAIL = "YCHT_GROUP_SHOW_DETAIL",
    CLOSE_DETAIL = "YCHT_GROUP_CLOSE_DETAIL",

    CHANGE_SELECTED_IDS = "YCHT_GROUP_CHANGE_SELECTED_IDS",

    SHOW_CONFIRM = "YCHT_GROUP_SHOW_CONFIRM",
    CLOSE_CONFIRM = "YCHT_GROUP_CLOSE_CONFIRM",

    DELETE_START = "YCHT_GROUP_DELETE_START",
    DELETE_SUCCESS = "YCHT_GROUP_DELETE_SUCCESS",
    DELETE_ERROR = "YCHT_GROUP_DELETE_ERROR",

    SAVE_START = "YCHT_GROUP_SAVE_START",
    SAVE_SUCCESS = "YCHT_GROUP_SAVE_SUCCESS",
    SAVE_ERR = "YCHT_GROUP_SAVE_ERR"
}

export interface IYCHTGroupLoadStart {
    type: eYCHTGroupActionTypeIds.LOAD_START,
}
export interface IYCHTGroupLoadSuccess {
    type: eYCHTGroupActionTypeIds.LOAD_SUCCESS,
    payload: app_yeu_cau_ho_tro_group[]
}
export interface IYCHTGroupLoadErr {
    type: eYCHTGroupActionTypeIds.LOAD_ERROR,
    payload: string
}
export interface IYCHTGroupSelectStart {
    type: eYCHTGroupActionTypeIds.SELECT_START,
    payload: IPLTuanSelectRequest
}
export interface IYCHTGroupSelectSuccess {
    type: eYCHTGroupActionTypeIds.SELECT_SUCCESS,
    payload: app_yeu_cau_ho_tro_group[]
}
export interface IYCHTGroupSelectErr {
    type: eYCHTGroupActionTypeIds.SELECT_ERROR,
    payload: string
}
export interface IYCHTGroupShowDetail {
    type: eYCHTGroupActionTypeIds.SHOW_DETAIL,
    payload?: app_yeu_cau_ho_tro_group
}
export interface IYCHTGroupCloseDetail {
    type: eYCHTGroupActionTypeIds.CLOSE_DETAIL,
}
export interface IYCHTGroupChangeSelectedIds {
    type: eYCHTGroupActionTypeIds.CHANGE_SELECTED_IDS,
    payload: number[]
}
export interface IYCHTGroupShowConfirm {
    type: eYCHTGroupActionTypeIds.SHOW_CONFIRM
}
export interface IYCHTGroupCloseConfirm {
    type: eYCHTGroupActionTypeIds.CLOSE_CONFIRM
}

export interface IYCHTGroupDeleteStart {
    type: eYCHTGroupActionTypeIds.DELETE_START,
    payload: IDeleteMultipleBaseRequest
}
export interface IYCHTGroupDeleteSuccess {
    type: eYCHTGroupActionTypeIds.DELETE_SUCCESS,
}
export interface IYCHTGroupDeleteErr {
    type: eYCHTGroupActionTypeIds.DELETE_ERROR,
    payload: string
}
export interface IYCHTGroupSaveStart {
    type: eYCHTGroupActionTypeIds.SAVE_START,
    payload: app_yeu_cau_ho_tro_group
}
export interface IYCHTGroupSaveSuccess {
    type: eYCHTGroupActionTypeIds.SAVE_SUCCESS
}
export interface IYCHTGroupSaveErr {
    type: eYCHTGroupActionTypeIds.SAVE_ERR,
    payload: string
}


export type IYCHTGroupActionTypes = IYCHTGroupLoadStart | IYCHTGroupLoadSuccess | IYCHTGroupLoadErr |
    IYCHTGroupSelectStart | IYCHTGroupSelectSuccess | IYCHTGroupSelectErr |
    IYCHTGroupShowDetail | IYCHTGroupCloseDetail |
    IYCHTGroupChangeSelectedIds |
    IYCHTGroupShowConfirm | IYCHTGroupCloseConfirm |
    IYCHTGroupDeleteStart | IYCHTGroupDeleteSuccess | IYCHTGroupDeleteErr |
    IYCHTGroupSaveStart | IYCHTGroupSaveSuccess | IYCHTGroupSaveErr 